import React, { useRef } from 'react';
import * as turf from '@turf/turf';
import { makeStyles } from '@material-ui/core';

import { SEARCH_REDUCER } from '../../../../../redux/ReducerNames';

import SearchArea from '../../common/searcharea/SearchArea';
import SearchSettings from './SearchSettings';
import SearchActions from './SearchActions';
import SearchCriteria from './SearchCriteria';
import ScrollableContainer from '../../../../utility/ScrollableContainer';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => style(theme));

function Search () {
    const classes = useStyles();

    const source = useSelector(state => state.search.searchArea.layerId);
    const areaFacet = useSelector(state => state.lookups.uiData.facetChoices.find(el => el.id === state.search.searchArea.facetId));
    const areaFacetValue = useSelector(state => state.search.searchArea.facetValue);
    const areaFacetValid = useSelector(state => state.search.searchArea.facetValid);
    const geojson = useSelector(state => state.search.searchArea.geojson);
    // const criteria = useSelector(state => state.search.searchArea.criteria);
    // const isSearchDirty = useSelector(state => state.search.isSearchDirty);
    // const search = useSelector(state => state.search);

    const isSourcePresent = source ? true : false;
    const isSearchAreaPresent = (
        (areaFacet?.layerType === 'drawn' && geojson && turf.area(geojson?.geometry) > 0) || 
        (areaFacet?.layerType === 'fixed' && areaFacetValue && areaFacetValid) ||
        (areaFacet?.layerType === 'all')
    )
 
    const criteriaRef = useRef(null);

    function scrollToCriteria() {
        criteriaRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start"
        })
    }

    return (
        <>
            <ScrollableContainer className={classes.root}>
                <SearchSettings />
                { isSourcePresent ? 
                    <>
                        <div className={classes.border} />
                        <SearchArea 
                            reducerName={SEARCH_REDUCER}
                            reducerAreaKey="searchArea"
                            featureKey="siteFinder"
                            heading="2. Define your search area"
                        />
                        {
                            isSearchAreaPresent ? 
                            <>
                                <div className={classes.border} />
                                <SearchCriteria ref={criteriaRef}/>
                            </> :
                            <></>
                        }
                        
                    </> : 
                    <></>
                }
            </ScrollableContainer>
            { isSourcePresent && isSearchAreaPresent ?
                <>
                    <div className={classes.border} />
                    <div className={classes.root}>
                        <SearchActions onScrollToCriteria={scrollToCriteria}/>
                    </div>
                </> :
                <></>
            }
        </>
    );
}

const style = theme => ({
    root: {
        padding: theme.constants.spacing.xl,
        paddingTop: 20,
        paddingBottom: 24,
        '&> *:not(:last-child)':{
            marginBottom: theme.constants.verticalMargin
        }
    },
    border: {
        height: '1px',
        backgroundColor: theme.palette.background.border
    }
});

export default Search;